'use client';

import { SessionProvider as NextAuthSessionProvider } from 'next-auth/react';
import type { Session } from 'next-auth';
import { ReactNode } from 'react';
import { useAuthErrorHandler } from '@/hooks/use-auth-error-handler';
import { useAuthErrorSync } from '@/lib/hooks/use-auth-error-handler';

interface SessionProviderProps {
  children: ReactNode;
  session?: Session | null;
}

/**
 * Auth Error Handler Component
 * Automatically handles session errors (like token refresh failures)
 */
function AuthErrorHandler({ children }: { children: ReactNode }) {
  useAuthErrorHandler(); // Watches session.error === 'RefreshAccessTokenError'
  useAuthErrorSync(); // Multi-tab sync + auth-error event listener
  return <>{children}</>;
}

/**
 * Wrapper for NextAuth SessionProvider
 * Makes session available to all client components
 * Includes automatic error handling for token refresh failures
 */
export function SessionProvider({ children, session }: SessionProviderProps) {
  return (
    <NextAuthSessionProvider session={session}>
      <AuthErrorHandler>{children}</AuthErrorHandler>
    </NextAuthSessionProvider>
  );
}
